import {
  IBodyProductSearchTemp,
  ICatalogState,
  TCatalogFormatView,
  TQuerySearchArray,
} from 'interfaces/catalog.interface';
import * as CatalogTypes from './catalog.types';
import {
  IgetCatalogResponseData,
  IgetCatalogResponseDataItem,
  IProductFetchDataResponse,
} from 'api/endpoints/catalog/catalog.response.interface';

export type TcatalogDispatchReducer =
  | {
      type: typeof CatalogTypes.GET_CATALOG;
      payload: IgetCatalogResponseData;
    }
  | {
      type: typeof CatalogTypes.ADD_MORE_TO_CATALOG;
      payload: IgetCatalogResponseData;
    }
  | {
      type: typeof CatalogTypes.GET_PRODUCT;
      payload: IProductFetchDataResponse;
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_MORE_PRODUCTS;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_RELATED_PRODUCTS;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.ADD_LIKE;
      payload: {
        productId: string;
        favorite: {
          favorite_id: string;
          user_id: string;
        };
      };
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_ADD_LIKE;
      payload: {
        productId: string;
        isLoading: boolean;
      };
    }
  | {
      type: typeof CatalogTypes.REMOVE_LIKE;
      payload: {
        productId: string;
        favorite_id: string;
      };
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_REMOVE_LIKE;
      payload: {
        productId: string;
        isLoading: boolean;
      };
    }
  | {
      type: typeof CatalogTypes.SET_BODY_PRODUCT;
      payload: {
        brandId: string[];
        clientId: string;
        limit: number;
        languageId: string;
      };
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_SET_BODY_PRODUCT;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.SET_BODY_PRODUCT_SEARCH;
      payload: IBodyProductSearchTemp;
    }
  | {
      type: typeof CatalogTypes.SET_BODY_PRODUCT_SEARCH_TEMP;
      payload: IBodyProductSearchTemp;
    }
  | {
      type: typeof CatalogTypes.SET_QUERY_SEARCH;
      payload: string;
    }
  | {
      type: typeof CatalogTypes.ADD_BODY_FILTERS;
      payload: {
        bodyProductSearchTemp: IBodyProductSearchTemp;
        field: string;
      };
    }
  | {
      type: typeof CatalogTypes.REMOVE_BODY_FILTERS;
      payload: {
        bodyProductSearchTemp: IBodyProductSearchTemp;
        field: string;
      };
    }
  | {
      type: typeof CatalogTypes.ADD_TO_QUERY_SEARCH_ARRAY;
      payload: TQuerySearchArray;
    }
  | {
      type: typeof CatalogTypes.REMOVE_FROM_QUERY_SEARCH_ARRAY;
      payload: TQuerySearchArray;
    }
  | {
      type: typeof CatalogTypes.SET_BODY_SEARCH_FILTER;
      payload: {
        querySearchArray: TQuerySearchArray[];
        field: string;
        value: TQuerySearchArray;
      };
    }
  | {
      type: typeof CatalogTypes.RESET_BODY_FILTERS;
      payload?: null;
    }
  | {
      type: typeof CatalogTypes.INCREMENT_PAGINATION_INDEX;
      payload: number;
    }
  | {
      type: typeof CatalogTypes.SET_THERE_ARE_MORE_PRODUCTS;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.SET_IS_EMPTY_PRODUCTS;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.SET_SORT_BY;
      payload: string;
    }
  | {
      type: typeof CatalogTypes.SET_PRICE_SLIDERS;
      payload: {
        field: string;
        value: Array<number>;
      };
    }
  | {
      type: typeof CatalogTypes.SET_BRAND_SELECTED;
      payload: {
        id: string;
        name: string;
        logo: string;
      };
    }
  | {
      type: typeof CatalogTypes.SET_FAVORITES;
      payload: string | null;
    }
  | {
      type: typeof CatalogTypes.SET_FILTERS_LENGTHS;
      payload: {
        brand: number;
        color: number;
        gender: number;
        division: number;
        family: number;
        season: number;
      };
    }
  | {
      type: typeof CatalogTypes.SET_QUERY_SEARCH_ARRAY;
      payload: Array<TQuerySearchArray>;
    }
  | {
      type: typeof CatalogTypes.SET_RELATED_PRODUCTS;
      payload: {
        data: IgetCatalogResponseDataItem[];
        count: number;
        active_seasons: number;
        published_catalogs: number;
        total: number;
        of: number;
      };
    }
  | {
      type: typeof CatalogTypes.SET_IS_LOADING_PRODUCT;
      payload: boolean;
    }
  | {
      type: typeof CatalogTypes.RESET_PRICE_SLIDER;
      payload: { type: string };
    }
  | {
      type: typeof CatalogTypes.RESET_CATALOG;
      payload?: null;
    }
  | {
      type: typeof CatalogTypes.RESET_TEMP_BODY_FILTERS;
      payload?: null;
    }
  | {
      type: typeof CatalogTypes.ADD_BODY_BRAND_OPTIONS;
      payload: {
        bodyProductSearchTemp: IBodyProductSearchTemp;
      };
    }
  | {
      type: typeof CatalogTypes.REMOVE_BODY_BRAND_OPTIONS;
      payload: {
        bodyProductSearchTemp: IBodyProductSearchTemp;
      };
    }
  | {
      type: typeof CatalogTypes.SET_FORMAT_VIEW;
      payload: TCatalogFormatView;
    };

export default function catalogReducer(
  state: ICatalogState,
  action: TcatalogDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case CatalogTypes.GET_CATALOG: {
      const getCatalog: ICatalogState = {
        ...state,
        catalogItems: payload,
      };
      return getCatalog;
    }

    case CatalogTypes.SET_RELATED_PRODUCTS: {
      const setRelatedProducts: ICatalogState = {
        ...state,
        relatedProducts: payload,
      };
      return setRelatedProducts;
    }

    case CatalogTypes.ADD_MORE_TO_CATALOG: {
      const addMoreToCatalog: ICatalogState = {
        ...state,
        catalogItems: {
          ...(state.catalogItems as IgetCatalogResponseData),
          data: (state.catalogItems as IgetCatalogResponseData).data.concat(payload.data),
        },
      };
      return addMoreToCatalog;
    }

    case CatalogTypes.GET_PRODUCT: {
      const getProduct: ICatalogState = {
        ...state,
        productItem: payload,
      };
      return getProduct;
    }

    case CatalogTypes.SET_IS_LOADING: {
      const setIsLoading: ICatalogState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    case CatalogTypes.SET_IS_LOADING_MORE_PRODUCTS: {
      const setIsLoadingMoreProducts: ICatalogState = {
        ...state,
        isLoadingMoreProducts: payload,
      };
      return setIsLoadingMoreProducts;
    }

    case CatalogTypes.SET_IS_LOADING_RELATED_PRODUCTS: {
      const setIsLoadingRelatedProducts: ICatalogState = {
        ...state,
        isLoadingRelatedProducts: payload,
      };
      return setIsLoadingRelatedProducts;
    }

    case CatalogTypes.ADD_LIKE: {
      let addLikeState: ICatalogState = {
        ...state,
      };
      if (addLikeState.catalogItems) {
        addLikeState = {
          ...addLikeState,
          catalogItems: {
            ...(addLikeState.catalogItems as IgetCatalogResponseData),
            data: (addLikeState.catalogItems as IgetCatalogResponseData).data?.map(
              (item) => {
                if (item.id === payload.productId) {
                  return {
                    ...item,
                    favorite: [...item.favorite, payload.favorite],
                  };
                }
                return item;
              }
            ),
          },
        };
      }
      if (addLikeState.relatedProducts) {
        addLikeState = {
          ...addLikeState,
          relatedProducts: {
            ...(addLikeState.relatedProducts as IgetCatalogResponseData),
            data: (addLikeState.relatedProducts as IgetCatalogResponseData)?.data?.map(
              (item) => {
                if (item.id === payload.productId) {
                  return {
                    ...item,
                    favorite: [...item.favorite, payload.favorite],
                  };
                }
                return item;
              }
            ),
          },
        };
      }
      if (
        addLikeState.productItem &&
        addLikeState.productItem.product_id === payload.productId
      ) {
        addLikeState = {
          ...addLikeState,
          productItem: {
            ...addLikeState.productItem,
            favorite: [...addLikeState.productItem.favorite, payload.favorite],
          },
        };
      }
      return addLikeState;
    }

    case CatalogTypes.SET_IS_LOADING_ADD_LIKE: {
      const setIsLoadingAddLike: ICatalogState = {
        ...state,
        isLoadingAddLike: {
          productId: payload.productId,
          isLoading: payload.isLoading,
        },
      };
      return setIsLoadingAddLike;
    }

    case CatalogTypes.REMOVE_LIKE: {
      let removeLikeState: ICatalogState = {
        ...state,
      };
      if (removeLikeState.catalogItems) {
        removeLikeState = {
          ...removeLikeState,
          catalogItems: {
            ...(removeLikeState.catalogItems as IgetCatalogResponseData),
            data: (removeLikeState.catalogItems as IgetCatalogResponseData).data?.map(
              (item) => {
                if (item.id === payload.productId) {
                  return {
                    ...item,
                    favorite: item.favorite.filter(
                      (favorite) => favorite.favorite_id !== payload.favorite_id
                    ),
                  };
                }
                return item;
              }
            ),
          },
        };
      }
      if (removeLikeState.relatedProducts) {
        removeLikeState = {
          ...removeLikeState,
          relatedProducts: {
            ...(removeLikeState.relatedProducts as IgetCatalogResponseData),
            data: (removeLikeState.relatedProducts as IgetCatalogResponseData).data?.map(
              (item) => {
                if (item.id === payload.productId) {
                  return {
                    ...item,
                    favorite: item.favorite.filter(
                      (favorite) => favorite.favorite_id !== payload.favorite_id
                    ),
                  };
                }
                return item;
              }
            ),
          },
        };
      }
      if (
        removeLikeState.productItem &&
        removeLikeState.productItem.product_id === payload.productId
      ) {
        removeLikeState = {
          ...removeLikeState,
          productItem: {
            ...(removeLikeState.productItem as IProductFetchDataResponse),
            favorite: (
              removeLikeState.productItem as IProductFetchDataResponse
            ).favorite.filter((favorite) => favorite.favorite_id !== payload.favorite_id),
          },
        };
      }
      return removeLikeState;
    }

    case CatalogTypes.SET_IS_LOADING_REMOVE_LIKE: {
      const setIsLoadingRemoveLike: ICatalogState = {
        ...state,
        isLoadingRemoveLike: {
          productId: payload.productId,
          isLoading: payload.isLoading,
        },
      };
      return setIsLoadingRemoveLike;
    }

    case CatalogTypes.RESET_PRICE_SLIDER: {
      const resetPriceSlider: ICatalogState = {
        ...state,
        bodyProductSearch: {
          ...state.bodyProductSearch,
          filter: {
            ...state.bodyProductSearch.filter,
            [payload.type]: [],
          },
        },
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          filter: {
            ...state.bodyProductSearchTemp.filter,
            [payload.type]: [],
          },
        },
      };
      return resetPriceSlider;
    }

    case CatalogTypes.RESET_TEMP_BODY_FILTERS: {
      const resetTempBodyFilters: ICatalogState = {
        ...state,
        bodyProductSearchTemp: state.bodyProductSearch,
        filtersLengthsTemp: state.filtersLengths,
      };
      return resetTempBodyFilters;
    }

    case CatalogTypes.SET_BODY_PRODUCT: {
      const setBodyProduct: ICatalogState = {
        ...state,
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          options: {
            ...state.bodyProductSearchTemp.options,
            brand_id: payload.brandId,
            client_id: [payload.clientId],
            limit: payload.limit,
            language_id: payload.languageId,
          },
          filter: {
            reference: [],
            color: [],
            season: [],
            segmentation: [],
            division: [],
            family: [],
            gender: [],
            pvi: [],
            pvpr: [],
            tag: [],
            tier: [],
          },
        },
        bodyProductSearch: {
          ...state.bodyProductSearch,
          options: {
            ...state.bodyProductSearch.options,
            brand_id: payload.brandId,
            client_id: [payload.clientId],
            limit: payload.limit,
            language_id: payload.languageId,
          },
          filter: {
            reference: [],
            color: [],
            season: [],
            segmentation: [],
            division: [],
            family: [],
            gender: [],
            pvi: [],
            pvpr: [],
            tag: [],
            tier: [],
          },
        },
        querysearchArray: [],
        filtersLengths: {
          brand: payload.brandId.length,
          color: 0,
          gender: 0,
          division: 0,
          family: 0,
          season: 0,
        },
      };
      return setBodyProduct;
    }

    case CatalogTypes.SET_IS_LOADING_SET_BODY_PRODUCT: {
      const setIsLoadingSetBodyProduct: ICatalogState = {
        ...state,
        isLoadingSetBodyProduct: payload,
      };
      return setIsLoadingSetBodyProduct;
    }

    case CatalogTypes.SET_BODY_PRODUCT_SEARCH: {
      const setBodyProductSearch: ICatalogState = {
        ...state,
        bodyProductSearch: payload,
        filtersLengths: {
          brand: payload.options.brand_id.length,
          color: state.filtersLengthsTemp.color,
          gender: state.filtersLengthsTemp.gender,
          division: state.filtersLengthsTemp.division,
          family: state.filtersLengthsTemp.family,
          season: state.filtersLengthsTemp.season,
        },
      };
      return setBodyProductSearch;
    }

    case CatalogTypes.SET_BODY_PRODUCT_SEARCH_TEMP: {
      const setBodyProductSearchTemp: ICatalogState = {
        ...state,
        bodyProductSearchTemp: payload,
      };
      return setBodyProductSearchTemp;
    }

    case CatalogTypes.SET_QUERY_SEARCH: {
      const setQuerySearch: ICatalogState = {
        ...state,
        querySearch: payload,
      };
      return setQuerySearch;
    }

    case CatalogTypes.INCREMENT_PAGINATION_INDEX: {
      const incrementPaginationIndex: ICatalogState = {
        ...state,
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          options: {
            ...state.bodyProductSearchTemp.options,
            index: payload,
          },
        },
      };
      return incrementPaginationIndex;
    }

    case CatalogTypes.SET_PRICE_SLIDERS: {
      const setPriceSliders: ICatalogState = {
        ...state,
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          filter: {
            ...state.bodyProductSearchTemp.filter,
            [payload.field]: payload.value,
          },
        },
      };
      return setPriceSliders;
    }

    case CatalogTypes.ADD_BODY_FILTERS: {
      const addBodyFilters: ICatalogState = {
        ...state,
        bodyProductSearchTemp: payload.bodyProductSearchTemp,
        filtersLengthsTemp: {
          ...state.filtersLengthsTemp,
          [payload.field]:
            state.filtersLengthsTemp[
              payload.field as keyof typeof state.filtersLengthsTemp
            ] + 1,
        },
      };
      return addBodyFilters;
    }

    case CatalogTypes.REMOVE_BODY_FILTERS: {
      const removeBodyFilters: ICatalogState = {
        ...state,
        bodyProductSearchTemp: payload.bodyProductSearchTemp,
        filtersLengthsTemp: {
          ...state.filtersLengthsTemp,
          [payload.field]:
            state.filtersLengthsTemp[
              payload.field as keyof typeof state.filtersLengthsTemp
            ] - 1,
        },
      };
      return removeBodyFilters;
    }

    case CatalogTypes.ADD_BODY_BRAND_OPTIONS: {
      const addBodyBrandOptions: ICatalogState = {
        ...state,
        bodyProductSearchTemp: payload.bodyProductSearchTemp,
        filtersLengths: {
          ...state.filtersLengths,
          brand: state.filtersLengths.brand + 1,
        },
      };
      return addBodyBrandOptions;
    }

    case CatalogTypes.REMOVE_BODY_BRAND_OPTIONS: {
      const removeBodyBrandOptions: ICatalogState = {
        ...state,
        bodyProductSearchTemp: payload.bodyProductSearchTemp,
        filtersLengths: {
          ...state.filtersLengths,
          brand: state.filtersLengths.brand - 1,
        },
      };
      return removeBodyBrandOptions;
    }

    case CatalogTypes.RESET_BODY_FILTERS: {
      const resetBodyFilters: ICatalogState = {
        ...state,
        bodyProductSearch: {
          ...state.bodyProductSearch,
          options: {
            ...state.bodyProductSearch.options,
            favorite: '',
            index: 0,
          },
          filter: {
            ...state.bodyProductSearch.filter,
            color: [],
            season: [],
            segmentation: [],
            division: [],
            family: [],
            gender: [],
            pvi: [],
            pvpr: [],
            tag: [],
            tier: [],
          },
        },
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          options: {
            ...state.bodyProductSearchTemp.options,
            favorite: '',
            index: 0,
          },
          filter: {
            ...state.bodyProductSearchTemp.filter,
            color: [],
            season: [],
            segmentation: [],
            division: [],
            family: [],
            gender: [],
            pvi: [],
            pvpr: [],
            tag: [],
            tier: [],
          },
        },
        filtersLengths: {
          brand: 0,
          color: 0,
          gender: 0,
          division: 0,
          family: 0,
          season: 0,
        },
        filtersLengthsTemp: {
          brand: 0,
          color: 0,
          gender: 0,
          division: 0,
          family: 0,
          season: 0,
        },
        querysearchArray: [],
      };
      return resetBodyFilters;
    }

    case CatalogTypes.SET_THERE_ARE_MORE_PRODUCTS: {
      const setThereAreMoreProducts: ICatalogState = {
        ...state,
        thereAreMoreProducts: payload,
      };
      return setThereAreMoreProducts;
    }

    case CatalogTypes.SET_IS_EMPTY_PRODUCTS: {
      const setIsEmptyProducts: ICatalogState = {
        ...state,
        isEmptyProducts: payload,
      };
      return setIsEmptyProducts;
    }

    case CatalogTypes.SET_SORT_BY: {
      const setSortBy: ICatalogState = {
        ...state,
        bodyProductSearch: {
          ...state.bodyProductSearch,
          options: {
            ...state.bodyProductSearch.options,
            order: [payload],
          },
        },
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          options: {
            ...state.bodyProductSearchTemp.options,
            order: [payload],
          },
        },
      };
      return setSortBy;
    }

    case CatalogTypes.SET_BRAND_SELECTED: {
      const setBrandSelected: ICatalogState = {
        ...state,
        brandSelected: payload,
      };
      return setBrandSelected;
    }

    case CatalogTypes.SET_FAVORITES: {
      const setFavorites: ICatalogState = {
        ...state,
        bodyProductSearchTemp: {
          ...state.bodyProductSearchTemp,
          options: {
            ...state.bodyProductSearchTemp.options,
            favorite: payload,
          },
        },
      };
      return setFavorites;
    }

    case CatalogTypes.SET_FILTERS_LENGTHS: {
      const setFiltersLengths: ICatalogState = {
        ...state,
        filtersLengthsTemp: payload,
      };
      return setFiltersLengths;
    }

    case CatalogTypes.SET_IS_LOADING_PRODUCT: {
      const setIsLoadingProduct: ICatalogState = {
        ...state,
        isLoadingProduct: payload,
      };
      return setIsLoadingProduct;
    }

    case CatalogTypes.ADD_TO_QUERY_SEARCH_ARRAY: {
      const addToQuerySearchArray: ICatalogState = {
        ...state,
        querysearchArray: !state.querysearchArray.includes(payload)
          ? [...state.querysearchArray, payload]
          : state.querysearchArray,
      };
      return addToQuerySearchArray;
    }

    case CatalogTypes.REMOVE_FROM_QUERY_SEARCH_ARRAY: {
      const removeFromQuerySearchArray: ICatalogState = {
        ...state,
        querysearchArray: state.querysearchArray.filter(
          (item) => item.tag !== payload.tag
        ),
      };
      return removeFromQuerySearchArray;
    }

    case CatalogTypes.SET_QUERY_SEARCH_ARRAY: {
      const setQuerySearchArray: ICatalogState = {
        ...state,
        querysearchArray: payload,
      };
      return setQuerySearchArray;
    }

    case CatalogTypes.SET_BODY_SEARCH_FILTER: {
      const setBodySearchFilter: ICatalogState = {
        ...state,
        querysearchArray: (payload.querySearchArray as TQuerySearchArray[]).filter(
          (item) => item.tag !== payload.value.tag
        ),
        filtersLengthsTemp: {
          ...state.filtersLengthsTemp,
          [payload.field]:
            state.filtersLengthsTemp[
              payload.field as keyof typeof state.filtersLengthsTemp
            ] - 1,
        },
      };
      return setBodySearchFilter;
    }

    case CatalogTypes.RESET_CATALOG: {
      const resetCatalogItems: ICatalogState = {
        ...state,
        catalogItems: {
          active_seasons: 0,
          published_catalogs: 0,
          total: 0,
          of: 0,
          count: 0,
          data: [],
        },
        relatedProducts: {
          active_seasons: 0,
          published_catalogs: 0,
          total: 0,
          of: 0,
          count: 0,
          data: [],
        },
        querySearch: '',
        querysearchArray: [],
        productItem: null,
        thereAreMoreProducts: false,
      };
      return resetCatalogItems;
    }

    case CatalogTypes.SET_FORMAT_VIEW: {
      const setFormatView: ICatalogState = {
        ...state,
        formatView: payload,
      };
      return setFormatView;
    }

    default:
      return state;
  }
}
